import {useState, useEffect} from "react";
import BaseComponent from "../BaseComponent";
import ScriptInput from "components/Properties/InputComponents/ScriptInput";
import {ReactComponent as Plus} from "assets/image/Layout/PropertyPanel/ic_plus.svg";
import styles from "./index.module.scss";

const ScriptComponent = ({target, isObjectScripting, addUserScript, editUserScript, removeUserScript, textOnChange, setScriptIndex}) => {
  const [isNewScript, setIsNewScript] = useState(false);
  useEffect(() => {
    setIsNewScript(true);
    return () => setIsNewScript(false);
  }, [target]);

  if (isObjectScripting) {
    return (
      <>
        <BaseComponent title="Server Script" foldable={false}>
          <div className={styles.add_button_anchor}>
            <Plus className={styles.add_button} onClick={() => addUserScript("serverScript")} />
          </div>
          {target.userData.objectScripts?.serverScripts &&
            target.userData.objectScripts.serverScripts.map((script, index) => {
              return (
                <ScriptInput
                  key={index}
                  name="ServerScriptTitle"
                  index={index}
                  value={script.title}
                  onClickEdit={() => editUserScript("serverScript", index, script.title, script.source, target)}
                  onClickRemove={() => removeUserScript("serverScript", script.title, index)}
                  textOnChange={textOnChange}
                  inputOnFocus={setScriptIndex}
                  isNewScript={isNewScript}
                />
              );
            })}
        </BaseComponent>
        <BaseComponent title="Client Script" foldable={false}>
          <div className={styles.add_button_anchor}>
            <Plus className={styles.add_button} onClick={() => addUserScript("clientScript")} />
          </div>
          {target.userData.objectScripts?.clientScripts &&
            target.userData.objectScripts.clientScripts.map((script, index) => {
              return (
                <ScriptInput
                  key={index}
                  name="ClientScriptTitle"
                  index={index}
                  value={script.title}
                  onClickEdit={() => editUserScript("clientScript", index, script.title, script.source, target)}
                  onClickRemove={() => removeUserScript("clientScript", script.title, index)}
                  textOnChange={textOnChange}
                  inputOnFocus={setScriptIndex}
                  isNewScript={isNewScript}
                />
              );
            })}
        </BaseComponent>
      </>
    );
  } else {
    return null;
  }
};

export default ScriptComponent;
